import "./TypeDefinition";
/**
 * Get minigame from minigames config by its name.
 * @param {string} name - task name
 * @param {ConstrainedMinigamesConfig} config - minigames config
 */
export default function getMinigameByName(name, config) {
	return (config || this).minigames.filter(mg => mg.name === name)[0] || (config || this).initMinigames.filter(mg => mg.name === name)[0];
}
